export default __webpack_public_path__ + "static/media/nyc.ced7c893.jpg";